import React, { useEffect, useRef, useState } from 'react';
import './AstoundAccount.scss';
import PostHeader from '../../../components/Header/PostHeader';
import Footer from '../../../components/Footer/Footer';
import image1 from '../../../Assets/images/commonImages/ipadBanner.webp';
import image2 from '../../../Assets/images/commonImages/ipadBanner.webp';
import image from '../../../Assets/images/commonImages/dektopBanner.webp';
// import image from '../../../Assets/images/PostActivation/Account/ACCOUNT-BANNER.webp';
// import { default as image1, default as image2 } from '../../../Assets/images/HomePage/homeiPadNewBanner.webp';
// import mobileImg from '../../../Assets/images/HomePage/homemWeb.webp';
import backArrow from '../../../Assets/images/PostActivation/Account/backArrow.svg';
import downArrow from '../../../Assets/images/PostActivation/Account/DROP_ICON.svg';
import upArrow from '../../../Assets/images/PostActivation/Account/CLOSE_ICON.svg';
import leftArrow from '../../../Assets/images/PostActivation/Account/Chevron_Right.svg';
import rightArrow from '../../../Assets/images/PostActivation/Account/Chevron_Right 2.svg';
import { globalVal } from '../../../global/globalvalues';
import { altText } from '../../../global/altText';
import { seoData } from '../../../global/seoData';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
    changePlan,
    customerGroup,
    dataCutOff,
    planChangeCustomerStatus,
    topUpGroup,
} from '../../../store/PostActivation/actions';
import { CircularProgress } from '@material-ui/core';
import { userPlans } from '../../../store/Billing/actions';
import Button from '../../../components/Button/Button';
import { reachPlans } from '../../../store/HomePage/actions';
import successIcon from '../../../Assets/images/Activation/success.svg';
import failedIcon from '../../../Assets/images/Activation/failed.svg';
import pendingIcon from '../../../Assets/images/Activation/inProgress.svg';
import {
    GetCustomer,
    // ---- HSD Changes ------
    Coupon,
} from '../../../store/Checkout/actions';
import Switch from '@material-ui/core/Switch';
import moment from 'moment';
import { dataUsage, currentDataUsage } from '../../../store/Activation/actions';
import { bytesToSize, converDataFromBytes } from '../../../global/commonFunctions/ConverDataFromBytes';
import { toNumber } from 'lodash';
import { textTruncate } from '../../../global/commonFunctions/TextTruncate';
import { isHSDEnabled } from '../../../config';
// import { pushTrackingEventsToGAAndFBNew } from '../../../global/commonFunctions/GaAndFb';
import TagManager from 'react-gtm-module';
import { returnName } from '../../../global/commonFunctions/getUserName';

type initialProps = {
    history: any;
};

const AstoundAccount = (props: initialProps) => {
    const [loader, setLoader] = useState(true);
    const [user, setUser] = useState<any>(null);
    const [groupData, setGroupData] = useState<any>(null);
    const [planData, setPlanData] = useState<any>(null);
    const [isChangePlanJourney, setIsChangePlanJourney] = useState(false);
    const [isChangePlan, setIsChangePlan] = useState(false);
    const [isReviewPlan, setIsReviewPlan] = useState(false);
    const [isConfirmPlan, setIsConfirmPlan] = useState(false);
    const [isUpgradeNow, setIsUpgradeNow] = useState(false);
    const [isUpgradePlan, setIsUpgradePlan] = useState(false);
    const [isChangePlanSuccess, setIsChangePlanSuccess] = useState(false);
    const [isChangePlanLaterSuccess, setIsChangePlanLaterSuccess] = useState(false);
    const [isChangePlanFailed, setIsChangePlanFailed] = useState(false);
    const [isChangePlanLoader, setIsChangePlanLoader] = useState(false);
    const [pauseDataLoader, setPauseDataLoader] = useState(false);
    const [pauseUserData, setPauseUserData] = useState('');
    const [selectedPlan, setSelectedPlan] = useState<any>(null);
    const [viewUserHistory, setViewUserHistory] = useState('');
    const [currentPlan, setCurrentPlan] = useState<any>(null);
    const [topupHistory, setTopupHistory] = useState<any>('');
    const [isTopupHistoryLoader, setIsTopupHistoryLoader] = useState(false);
    const [isViewMoreData, setIsViewMoreData] = useState<any>('');
    const [showStartDate, setShowStartDate] = useState<any>(null);
    const [showEndDate, setShowEndDate] = useState<any>(null);
    const [currentUsage, setCurrentUsage] = useState<any>(null);
    const [totalDataUsage, setTotalDataUsage] = useState<any>(null);
    const [currentEl, setCurrentEl] = useState<any>(null);
    const [width, setWidth] = useState<any>(window.innerWidth);
    // ---- HSD Changes ------
    const [primaryHsdDiscount, setPrimaryHsdDiscount] = useState<number>(0);
    const [secHsdDiscount, setSecHsdDiscount] = useState<number>(0);
    const [isHsdCustomer, setIsHsdCustomer] = useState<boolean>(false);

    // const [usageIndex, setUsageIndex] = useState<any>(null);
    // const [maxData, setMaxData] = useState<any>(null);
    // const [dataUsed, setDataUsed] = useState<any>(null);
    const [isLeftArrow, setIsLeftArrow] = useState(false);
    const [isRightArrow, setIsRightArrow] = useState(false);
    const [showChangePlan, setShowChangePlan] = useState(false);
    const [currentPlanPrice, setCurrentPlanPrice] = useState(0);
    const [newPlanPrice, setNewPlanPrice] = useState(0);
    const [sortedUsageEndDate, setSortedUsageEndDate] = useState<any>(null);
    const [isPlanChangeInitiated, setIsPlanChangeInitiated] = useState(false);
    const [currentUsageError, setCurrentUsageError] = useState(false);
    const [numOfLines, setNumOfLines] = useState<number>(0);
    const [isFraudAcc, setIsFraudAcc] = useState<boolean>(false);
    const [simSwapInProgress, setSimSwapInProgress] = useState<boolean>(false);

    const { postActivation, home, checkout, activation, billing } = useSelector((state: any) => state);
    const userPlan = useSelector((state: any) => state.billing.userPlans);
    const {getCustomer} = useSelector((state: any) => state.checkout);
    // ---- HSD Changes ------
    const { coupon } = useSelector((state: any) => state.checkout);
    const dispatch = useDispatch();

    const startDateRef: any = useRef('');
    const endDateRef: any = useRef('');
    const initialStatusRender = useRef(true);

    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        let currentPlan: any = localStorage.getItem('currentPlan');
        currentPlan = JSON.parse(currentPlan);
        let totalLines: any = localStorage.getItem('numOfLines');
        totalLines = JSON.parse(totalLines);
        setNumOfLines(totalLines);
        setUser(customerDetails);
        if(customerDetails?.category === 'FRAUD') {
            setIsFraudAcc(true);
        }
        setCurrentPlan(currentPlan);
        // ---- HSD Changes ------
        setIsHsdCustomer(customerDetails?.hsdPlan);
        const nextBillingDate = new Date(
            moment
                .utc(customerDetails.nextBillingDate)
                .subtract(1, 'months')
                .format('YYYY-MM-DD'),
        );
        const activationDate = new Date(moment.utc(customerDetails.activationDate).format('YYYY-MM-DD'));
        const showEndDate = new Date(
            moment
                .utc(customerDetails.nextBillingDate)
                .subtract(1, 'days')
                .format('YYYY-MM-DD'),
        );
        const activationDate_yr = activationDate.getFullYear();
        const nextBillingDate_yr = nextBillingDate.getFullYear();
        const activationDate_mth = activationDate.getMonth();
        const nextBillingDate_mth = nextBillingDate.getMonth();
        const activationDate_dt = activationDate.getDate();
        const nextBillingDate_dt = nextBillingDate.getDate();
        if (
            nextBillingDate_yr > activationDate_yr ||
            nextBillingDate_mth > activationDate_mth ||
            (nextBillingDate_mth === activationDate_mth && nextBillingDate_dt > activationDate_dt)
        ) {
            setShowStartDate(nextBillingDate);
            setShowEndDate(showEndDate);
            startDateRef.current = nextBillingDate;
            endDateRef.current = showEndDate;
        } else {
            setShowStartDate(activationDate);
            setShowEndDate(showEndDate);
            startDateRef.current = activationDate;
            endDateRef.current = showEndDate;
        }

        dispatch(
            GetCustomer({
                username: encodeURIComponent(customerDetails && customerDetails.emailId),
            }),
        );
        dispatch(customerGroup({ groupId: customerDetails && customerDetails.groupId }));
        dispatch(userPlans({ customerId: customerDetails?.id }));
        dispatch(dataUsage({ customerId: customerDetails && customerDetails.id }));

        if (customerDetails && customerDetails.billStartDate && customerDetails.billEndDate) {
            dispatch(
                topUpGroup({
                    groupId: customerDetails && customerDetails.groupId,
                    startDate:
                        customerDetails &&
                        customerDetails.billStartDate &&
                        new Date(customerDetails.billStartDate).toISOString().slice(0, 10),
                    endDate:
                        customerDetails &&
                        customerDetails.billEndDate &&
                        new Date(customerDetails.billEndDate).toISOString().slice(0, 10),
                }),
            );
        }

        if (customerDetails && customerDetails.isPrimary) {
            dispatch(currentDataUsage({ customerId: customerDetails && customerDetails.id }));
        } else {
            dispatch(currentDataUsage({ customerId: customerDetails && customerDetails.parentId }));
        }
        dispatch(
            planChangeCustomerStatus({
                customerId: customerDetails && customerDetails.id,
            }),
        );
    }, []);

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current) {
            initialRender1.current = false;
        } else {
            if (
                postActivation &&
                postActivation.group &&
                postActivation.group.data &&
                postActivation.group.data.length > 0
            ) {
                setLoader(false);
                const showChangePlanCTA = postActivation.group.data.every(
                    (data: any) =>
                        data.status === 2 ||
                        data.status === 4 ||
                        data.status === 5 ||
                        data.status === 6 ||
                        data.status === 7 ||
                        data.status === 10 ||
                        data.status === 11,
                );
                setShowChangePlan(showChangePlanCTA);
                setGroupData(postActivation.group.data);
            }
        }
    }, [postActivation.group]);

    const initialRender2 = useRef(true);
    useEffect(() => {
        if (initialRender2.current) {
            initialRender2.current = false;
        } else {
            if (userPlan && userPlan.status === 'SUCCESS' && userPlan.data) {
                localStorage.setItem('currentPlan', JSON.stringify(userPlan.data));
                setCurrentPlan(userPlan.data);
                dispatch(reachPlans());
            }
        }
    }, [userPlan]);

    const initialRender3 = useRef(true);
    useEffect(() => {
        if (initialRender3.current) {
            initialRender3.current = false;
        } else {
            if (home && home.plans && home.plans.status === 'SUCCESS' && home.plans.data) {
                setPlanData(home.plans.data);
                let couponName: any = null;
                home.plans.data.map((el: any) => {
                    if (el.name === currentPlan.name && el.wowCoupon) {
                        couponName = el.wowCoupon;
                    }
                });
                isHsdCustomer &&
                    isHSDEnabled &&
                    dispatch(
                        Coupon({
                            couponCode: couponName,
                        }),
                    );
            }
        }
    }, [home.plans]);

    // ---- HSD Changes ------
    useEffect(() => {
        if (coupon && coupon.status === 'SUCCESS' && coupon.data) {
            if (isHsdCustomer) {
                setPrimaryHsdDiscount(coupon?.data?.discountInDollar);
                setSecHsdDiscount(coupon?.data?.secondaryDiscountInDollar);
            }
        }
    }, [coupon]);

    const initialRender4 = useRef(true);
    useEffect(() => {
        if (initialRender4.current) {
            initialRender4.current = false;
        } else {
            if (
                postActivation &&
                postActivation.changePlan &&
                postActivation.changePlan.status === 'SUCCESS' &&
                postActivation.changePlan.data
            ) {
                dispatch(
                    GetCustomer({
                        username: encodeURIComponent(user && user.emailId),
                    }),
                );
                if (isUpgradeNow) {
                    setIsPlanChangeInitiated(true);
                    dispatch(
                        planChangeCustomerStatus({
                            customerId: user && user.id,
                        }),
                    );
                } else {
                    setIsChangePlanLoader(false);
                    setIsConfirmPlan(false);
                    setIsChangePlanLaterSuccess(true);
                }
            }
            if (
                postActivation &&
                postActivation.errorChangePlan &&
                postActivation.errorChangePlan.status === 'FAILURE'
            ) {
                setSelectedPlan('');
                setIsChangePlanLoader(false);
                setIsConfirmPlan(false);
                setIsChangePlanFailed(true);
            }
        }
    }, [postActivation.changePlan, postActivation.errorChangePlan]);

    const initialRender5 = useRef(true);
    useEffect(() => {
        if (initialRender5.current) {
            initialRender5.current = false;
        } else {
            if (
                postActivation &&
                postActivation.planChangeCustomerStatus &&
                postActivation.planChangeCustomerStatus.status === 'SUCCESS' &&
                postActivation.planChangeCustomerStatus.data
            ) {
                if (
                    postActivation.planChangeCustomerStatus.data.status === 'SUCCESSFUL' &&
                    !initialStatusRender.current
                ) {
                    setIsConfirmPlan(false);
                    setIsChangePlanLoader(false);
                    setIsChangePlanSuccess(true);
                    setIsPlanChangeInitiated(false);
                } else if (postActivation.planChangeCustomerStatus.data.status === 'IN_PROGRESS') {
                    setIsPlanChangeInitiated(true);
                    setIsConfirmPlan(false);
                    setIsChangePlanLoader(false);
                    setIsChangePlan(true);
                }
            }
            if (
                postActivation &&
                postActivation.errorPlanChangeCustomerStatus &&
                postActivation.errorPlanChangeCustomerStatus.status === 'FAILURE' &&
                !initialStatusRender.current
            ) {
                setIsConfirmPlan(false);
                setIsChangePlanLoader(false);
                setIsChangePlanFailed(true);
            }
            initialStatusRender.current = false;
        }
    }, [postActivation.planChangeCustomerStatus, postActivation.errorPlanChangeCustomerStatus]);

    const initialRender6 = useRef(true);
    useEffect(() => {
        if (initialRender6.current) {
            initialRender6.current = false;
        } else {
            if (
                checkout &&
                checkout.getCustomer &&
                checkout.getCustomer.status === 'SUCCESS' &&
                checkout.getCustomer.data
            ) {
                setUser(checkout.getCustomer.data);
            }
        }
    }, [checkout.getCustomer]);

    const initialRender7 = useRef(true);
    useEffect(() => {
        if (initialRender7.current) {
            initialRender7.current = false;
        } else {
            if (
                postActivation.dataCutOff &&
                postActivation.dataCutOff.status === 'SUCCESS' &&
                postActivation.dataCutOff.data
            ) {
                window.scroll(0, 0);
                dispatch(customerGroup({ groupId: user && user.groupId }));
                setPauseUserData('');
                setPauseDataLoader(false);

                let occurence: any = currentEl.peerAccountRef.split('|')[2];
                TagManager.dataLayer({
                    dataLayer: {
                        event: 'Data_Pause',
                        accountNo: user?.meta?.customer_statement_number,
                        line_number: occurence,
                        Data_Pause_Status: !postActivation.dataCutOff.data.isDataCutoff ? 'enable' : 'disable',
                    },
                });
                // GAAndFBEventsHandler(
                //     "Data_Pause",
                //     user?.meta?.customer_statement_number,occurence,
                //     !postActivation.dataCutOff.data.isDataCutoff
                // )
            }

            if (postActivation.errorDataCutOff && postActivation.errorDataCutOff.status === 'FAILURE') {
                setPauseDataLoader(false);
            }
        }
    }, [postActivation.dataCutOff, postActivation.errorDataCutOff]);

    useEffect(() => {
        if (
            postActivation.topUpGroup &&
            postActivation.topUpGroup.status === 'SUCCESS' &&
            postActivation.topUpGroup.data &&
            postActivation.topUpGroup.data.PURCHASED &&
            postActivation.topUpGroup.data.PURCHASED.length > 0
        ) {
            setTopupHistory(postActivation.topUpGroup.data.PURCHASED);
            setIsTopupHistoryLoader(false);
        }

        if (postActivation.errorTopUpGroup && postActivation.errorTopUpGroup.status === 'FAILURE') {
            setTopupHistory('');
            setIsTopupHistoryLoader(false);
        }
    }, [postActivation.topUpGroup, postActivation.errorTopUpGroup]);

    useEffect(() => {
        if (
            activation.dataUsage &&
            activation.dataUsage.status === 'SUCCESS' &&
            activation.dataUsage.data &&
            !_.isEmpty(activation.dataUsage.data)
        ) {
            setTotalDataUsage(activation.dataUsage.data);
            if (Object.keys(activation.dataUsage.data).length > 1) {
                // const usageIndex = Object.keys(activation.dataUsage.data).length - 1;
                // setUsageIndex(usageIndex);

                const sortedKeys = Object.keys(activation.dataUsage.data).sort((a: any, b: any) => {
                    const date1: any = new Date(a);
                    const date2: any = new Date(b);
                    return date1 - date2;
                });
                setSortedUsageEndDate(sortedKeys);
                setIsLeftArrow(true);
            }
        }
    }, [activation.dataUsage]);

    useEffect(() => {
        if (
            activation.currentDataUsage &&
            activation.currentDataUsage.status === 'SUCCESS' &&
            activation.currentDataUsage.data
        ) {
            setCurrentUsage(activation.currentDataUsage.data);
            // showDataUsage(activation.currentDataUsage.data);

            let customerDetails: any = localStorage.getItem('customerDetail');
            customerDetails = JSON.parse(customerDetails);
            const endDate = moment
                .utc(customerDetails?.nextBillingDate)
                .subtract(1, 'days')
                .format('YYYY-MM-DD');
            const data = activation.currentDataUsage.data[endDate];
            setShowStartDate(
                data.billStartDate ? data.billStartDate : showStartDate ? showStartDate : startDateRef.current,
            );
            setShowEndDate(data.billEndDate ? data.billEndDate : showEndDate ? showEndDate : endDateRef.current);
        }
        if (activation && activation.errorCurrentDataUsage && activation.errorCurrentDataUsage.status === 'FAILURE') {
            setCurrentUsageError(true);
        }
    }, [activation.currentDataUsage, activation.errorCurrentDataUsage]);
    
    const initialRender8 = useRef(true)
    useEffect(()=> {
        if (initialRender8.current) {
            initialRender8.current = false;
        } else {
            if (
                getCustomer &&
                getCustomer.status === 'SUCCESS' &&
                getCustomer.data &&
                getCustomer.data.operationsInProcess
            ) {
                if (getCustomer.data.operationsInProcess.includes('SIM_SWAP_IN_PROGRESS')) {
                    setSimSwapInProgress(true);
                    let customerDetails: any = localStorage.getItem('customerDetail');
                    customerDetails = JSON.parse(customerDetails);
                    let timer: any = 60000;
                    setTimeout(() => {
                        dispatch(
                            GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }),
                        );
                    }, timer);
                } else {
                    setSimSwapInProgress(false);
                }
            }
        }    
    },[getCustomer])

    const handleResize = () => {
        setWidth(window.innerWidth);
    }

    const changePlanHandler = () => {
        setIsChangePlanJourney(true);
        setIsChangePlan(true);
        TagManager.dataLayer({
            dataLayer: {
                event: 'Change_Plan',
            },
        });
        // GAAndFBEventsHandler("Change_Plan")
    };

    const selectingPlanHandler = (plan: any) => {
        setSelectedPlan(plan);
        localStorage.setItem('selectedPlanDetails', JSON.stringify(plan));
    };

    const handleChangePlanPrice = (el: any) => {
        let plan: any;
        if (user && user.reachPlanId === el.name) {
            plan = currentPlan;
        } else {
            plan = el;
        }
        let totalLines: any = localStorage.getItem('numOfLines');
        totalLines = JSON.parse(totalLines);
        const additionalLines = totalLines ? totalLines - 1 : 0;
        // const additionalLines = user ? user.totalActiveLines - 1 : 0;
        if (!plan.addLineSplitPrice) {
            return plan.baseLinePrice + additionalLines * plan.additionalLinePrice;
        } else {
            const addLinePrice = plan.addLineSplitPrice;
            if (additionalLines > 0) {
                let newPrice = 0;
                for (let i = 1; i <= additionalLines; i++) {
                    newPrice = newPrice + addLinePrice[i];
                }
                return plan.baseLinePrice + newPrice;
            } else {
                return plan.baseLinePrice;
            }
        }
    };

    const selectPlanAndProceed = () => {
        const currentPlanPrice = handleChangePlanPrice(currentPlan);
        const newPlanPrice = handleChangePlanPrice(selectedPlan);
        const isUpdateNow = showBothCTA();
        setIsUpgradePlan(isUpdateNow);
        setIsChangePlan(false);
        setIsReviewPlan(true);

        // ---- HSD Changes ------
        const totalActiveLines: any = user?.secondaryCustomers.length;
        if (isHsdCustomer && isHSDEnabled) {
            if (totalActiveLines === 1) {
                setCurrentPlanPrice(currentPlanPrice - primaryHsdDiscount);
                setNewPlanPrice(newPlanPrice - primaryHsdDiscount);
            } else if (totalActiveLines > 1) {
                setCurrentPlanPrice(currentPlanPrice - (primaryHsdDiscount + secHsdDiscount * totalActiveLines));
                setNewPlanPrice(newPlanPrice - (primaryHsdDiscount + secHsdDiscount * totalActiveLines));
            }
        } else {
            setCurrentPlanPrice(currentPlanPrice);
            setNewPlanPrice(newPlanPrice);
        }
    };

    const handleUpgrageCTA = (val: string) => {
        setIsReviewPlan(false);
        setIsConfirmPlan(true);
        if (val === 'now') {
            setIsUpgradeNow(true);
            TagManager.dataLayer({
                dataLayer: {
                    event: 'Change_Now',
                },
            });
            // GAAndFBEventsHandler("Change_Now")
        } else if (val === 'later') {
            setIsUpgradeNow(false);
            TagManager.dataLayer({
                dataLayer: {
                    event: 'Change_Later',
                },
            });
            // GAAndFBEventsHandler("Change_Later")
        }
    };

    const backHandler = () => {
        if (isChangePlan) {
            setIsChangePlan(false);
            setIsChangePlanJourney(false);
        } else if (isReviewPlan) {
            setIsReviewPlan(false);
            setIsChangePlan(true);
        } else if (isConfirmPlan) {
            setIsConfirmPlan(false);
            setIsReviewPlan(true);
        }
    };

    const confirmChangePlan = () => {
        setIsChangePlanLoader(true);
        dispatch(
            changePlan({
                newReachPlanId: selectedPlan && selectedPlan.name,
                immediateEffect: isUpgradeNow ? true : false,
                customerId: user && user.id,
            }),
        );
    };

    const showBothCTA = () => {
        if (
            (currentPlan?.baseLinePrice === selectedPlan?.baseLinePrice &&
                selectedPlan?.isUnlimited === currentPlan?.isUnlimited &&
                currentPlan?.planData < selectedPlan?.planData) ||
            (currentPlan?.baseLinePrice < selectedPlan?.baseLinePrice &&
                selectedPlan?.isUnlimited === currentPlan?.isUnlimited &&
                currentPlan?.planData < selectedPlan?.planData)
        ) {
            return true;
        }
        return false;
    };

    const handleEnablePauseData = (el: any) => {
        setPauseDataLoader(true);
        setCurrentEl(el);
        dispatch(
            dataCutOff({
                dataCutOff: el && !el.addedDataCutoff,
                primaryId: user && user.id,
                customerId: el && el.id,
            }),
        );
    };

    // const showDataUsage = (item: any) => {
    //     let endDate = user && user.billEndDate && new Date(user.billEndDate).toISOString().slice(0, 10);
    //     let data = item[endDate];

    //     if (data && data.group) {
    //         let use = data && data.group && data.group.bytes ? data.group.bytes : 0;
    //         let max = data && data.group && data.group.maxBytes ? data.group.maxBytes : 0;
    //         if (use > max) {
    //             use = max;
    //         }
    //         setMaxData(max);
    //         setDataUsed(use);
    //     } else if (data && data.users) {
    //         let findUser = data.users.length > 0 && data.users.find((el: any) => el.userId === (user && user.id));
    //         let use = findUser && findUser.bytes ? findUser.bytes : 0;
    //         let max = findUser && findUser.maxBytes ? findUser.maxBytes : 0;
    //         if (use > max) {
    //             use = max;
    //         }
    //         setMaxData(max);
    //         setDataUsed(use);
    //     }
    // };

    const onLeftClickHandler = async () => {
        const currentDateIndex = sortedUsageEndDate.indexOf(moment.utc(showEndDate).format('YYYY-MM-DD'));
        let startDate;
        if (
            user &&
            user.activationDate &&
            sortedUsageEndDate[currentDateIndex - 1].split('-')[0] === user.activationDate.split('-')[0] &&
            sortedUsageEndDate[currentDateIndex - 1].split('-')[1] === user.activationDate.split('-')[1]
        ) {
            startDate = moment.utc(user.activationDate).format('YYYY-MM-DD');
        } else {
            startDate = moment
                .utc(sortedUsageEndDate[currentDateIndex - 1])
                .add(1, 'days')
                .subtract(1, 'months')
                .format('YYYY-MM-DD');
        }
        let endDate = moment.utc(sortedUsageEndDate[currentDateIndex - 1]).format('YYYY-MM-DD');
        let key = _.findKey(totalDataUsage, function(_value: any, key: any) {
            return key == endDate;
        });

        // setUsageIndex(usageIndex - 1);
        // let totalDataUsageKeys = Object.keys(totalDataUsage);

        let firstFlag = false;
        if (sortedUsageEndDate[0] === endDate) {
            firstFlag = true;
        }

        if (key) {
            let data = totalDataUsage[key];
            if (data && data.billStartDate) {
                startDate = totalDataUsage[key]?.billStartDate ? totalDataUsage[key].billStartDate : startDate;
                endDate = totalDataUsage[key]?.billEndDate ? totalDataUsage[key].billEndDate : endDate;
            }

            if (data && data.group) {
                // let use = data && data.group && data.group.bytes ? data.group.bytes : 0;
                // let max = data && data.group && data.group.maxBytes ? data.group.maxBytes : 0;
                // if (use > max) {
                //     use = max;
                // }
                // setDataUsed(use);
                // setMaxData(max);
                setIsLeftArrow(firstFlag ? false : true);
                setIsRightArrow(true);
                setShowStartDate(startDate);
                setShowEndDate(endDate);
            } else if (data && data.users) {
                // let findUser = data.users.length > 0 && data.users.find((el: any) => el.userId === viewUserHistory);
                // let use = findUser && findUser.bytes ? findUser.bytes : 0;
                // let max = findUser && findUser.maxBytes ? findUser.maxBytes : 0;
                // if (use > max) {
                //     use = max;
                // }
                // setDataUsed(use);
                // setMaxData(max);
                setIsLeftArrow(firstFlag ? false : true);
                setIsRightArrow(true);
                setShowStartDate(startDate);
                setShowEndDate(endDate);
            }
        }
        setIsTopupHistoryLoader(true);
        dispatch(
            topUpGroup({
                groupId: user && user.groupId,
                startDate: moment.utc(startDate).format('YYYY-MM-DD'),
                endDate: moment.utc(endDate).format('YYYY-MM-DD'),
            }),
        );
    };

    const onRightClickHandler = () => {
        const currentDateIndex = sortedUsageEndDate.indexOf(moment.utc(showEndDate).format('YYYY-MM-DD'));
        let startDate = moment
            .utc(sortedUsageEndDate[currentDateIndex + 1])
            .add(1, 'days')
            .subtract(1, 'months')
            .format('YYYY-MM-DD');
        let endDate = moment.utc(sortedUsageEndDate[currentDateIndex + 1]).format('YYYY-MM-DD');

        let key = _.findKey(totalDataUsage, function(_value: any, key: any) {
            return key == endDate;
        });
        // setUsageIndex(usageIndex + 1);

        if (key) {
            let data = totalDataUsage[key];
            if (data && data.billStartDate) {
                startDate = totalDataUsage[key]?.billStartDate ? totalDataUsage[key].billStartDate : startDate;
                endDate = totalDataUsage[key]?.billEndDate ? totalDataUsage[key].billEndDate : endDate;
            }
            if (moment.utc(endDate).format('YYYY-MM-DD') === moment.utc(user.billEndDate).format('YYYY-MM-DD')) {
                setIsRightArrow(false);
            }
            if (data && data.group) {
                // let use = data && data.group && data.group.bytes ? data.group.bytes : 0;
                // let max = data && data.group && data.group.maxBytes ? data.group.maxBytes : 0;
                // if (use > max) {
                //     use = max;
                // }
                // setDataUsed(use);
                // setMaxData(max);
                setIsLeftArrow(true);
                setShowStartDate(startDate);
                setShowEndDate(endDate);
            } else if (data && data.users) {
                // let findUser = data.users.length > 0 && data.users.find((el: any) => el.userId === viewUserHistory);
                // let use = findUser && findUser.bytes ? findUser.bytes : 0;
                // let max = findUser && findUser.maxBytes ? findUser.maxBytes : 0;
                // if (use > max) {
                //     use = max;
                // }
                // setDataUsed(use);
                // setMaxData(max);
                setIsLeftArrow(true);
                setShowStartDate(startDate);
                setShowEndDate(endDate);
            }
            setIsTopupHistoryLoader(true);
            dispatch(
                topUpGroup({
                    groupId: user && user.groupId,
                    startDate: moment.utc(startDate).format('YYYY-MM-DD'),
                    endDate: moment.utc(endDate).format('YYYY-MM-DD'),
                }),
            );
        }
        // else {
        //     let userEndDate = moment.utc(user.billEndDate).format('YYYY-MM-DD');
        //     let data = currentUsage && currentUsage[userEndDate];

        //     let startDate = moment
        //         .utc(user.billEndDate)
        //         .add(1, 'days')
        //         .subtract(1, 'months')
        //         .format('YYYY-MM-DD');
        //     let endDate = moment.utc(user.billEndDate).format('YYYY-MM-DD');

        //     if (data && data.group) {
        //         // let use = data && data.group && data.group.bytes ? data.group.bytes : 0;
        //         // let max = data && data.group && data.group.maxBytes ? data.group.maxBytes : 0;
        //         // if (use > max) {
        //         //     use = max;
        //         // }
        //         // setDataUsed(use);
        //         // setMaxData(max);
        //         setIsLeftArrow(true);
        //         setIsRightArrow(false);
        //         setShowStartDate(startDate);
        //         setShowEndDate(user.billEndDate);
        //     } else if (data && data.users) {
        //         // let findUser = data.users.length > 0 && data.users.find((el: any) => el.userId === viewUserHistory);
        //         // let use = findUser && findUser.bytes ? findUser.bytes : 0;
        //         // let max = findUser && findUser.maxBytes ? findUser.maxBytes : 0;
        //         // if (use > max) {
        //         //     use = max;
        //         // }
        //         // setDataUsed(use);
        //         // setMaxData(max);
        //         setIsLeftArrow(true);
        //         setIsRightArrow(false);
        //         setShowStartDate(startDate);
        //         setShowEndDate(user.billEndDate);
        //     }
        //     setIsTopupHistoryLoader(true);
        //     dispatch(
        //         topUpGroup({
        //             groupId: user && user.groupId,
        //             startDate: startDate,
        //             endDate: endDate,
        //         }),
        //     );
        // }
    };
    // const GAAndFBEventsHandler = (buttonVal: string, accNumber?: any, lineNumber?:any, size?:any) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "Account",
    //       buttonValue: buttonVal,
    //       accNumber: accNumber,
    //       lineNumber: lineNumber,
    //       data: size,
    //     });
    //   };
    function convertToOrdinal(number: any) {
        const ordinalWords = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'];
        const value = parseInt(number);
        return ordinalWords[value];
    }
    return (
        <div className="AccountMain">
            <Helmet>
                <title>{seoData.account.title}</title>
                <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta property="og:title" name="title" content={seoData.account.title} />
                <meta property="og:description" name="description" content={seoData.account.description} />
                <meta name="description" content={seoData.account.description} />
                <meta name="keywords" content={seoData.account.keywords} />
                <meta name="robots" content="noindex, nofollow" />
                <meta property="twitter:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta name="twitter:title" content={seoData.account.title} />
                <meta name="twitter:description" content={seoData.account.description} />
                <link rel="canonical" href={seoData.account.canonicalUrl} />
            </Helmet>
            <PostHeader 
                history={props.history}
                showServiceTab={billing?.config?.data?.configs?.SERVICE_TAB === 'ENABLE' ? true : false} 
            // enableServiceInPrimarySus={billing?.config?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED}
            />
            <div className="OverlayPlan">
                <div className="carouseImage">
                    <img className="web" width="100%" src={image} alt={altText.planPage.mainImage} />
                    <img className="iPadPro" width="100%" src={image1} alt={altText.planPage.mainImage} />
                    <img className="iPad" width="100%" src={image2} alt={altText.planPage.mainImage} />
                    {/* <img
                        className="mobile"
                        src={mobileImg}
                        height={213}
                        width="100%"
                        alt={altText.planPage.mainImage}
                    /> */}
                    <div className="contentCarousel">
                        <h1 className="Goodbye-mobile-store">Account</h1>
                    </div>
                </div>
            </div>
            {!isChangePlanJourney ? (
                <div className="planDetails">
                    <div className="planTitle">
                        <div className="planName">Your Plan - {user && user.reachPlanId}</div>
                        {user && user.status === 2 && showChangePlan && (
                            <div
                                className={
                                    user && user.status === 3 || isFraudAcc ? 'changePlanCTA changePlanCTADisabled' : 'changePlanCTA'
                                }
                                onClick={() => {
                                    if (user.status === 3 || isFraudAcc) return;
                                    changePlanHandler();
                                }}
                            >
                                CHANGE PLAN
                            </div>
                        )}
                    </div>
                    {loader ? (
                        <div className="loaderCheck">
                            <CircularProgress />
                        </div>
                    ) : (
                        <>
                            {user && user.status === 3 && user.isPrimary || isFraudAcc && (
                                <div className="suspendedDiv">
                                    <div className="suspendedTitle">Let’s Talk</div>
                                    <div className="suspendedMsg">
                                        We’re sorry. The service you’re attempting to access or update is temporarily
                                        unavailable.
                                    </div>
                                    <div className="suspendedContact">
                                        Please contact us at <span>1.800.427.8686</span>
                                    </div>
                                </div>
                            )}
                            <div className="AccountLineCardContainer">
                                {groupData &&
                                    groupData
                                        .filter(
                                            (el: any) => el?.status === 2 ||
                                            el?.status == 3
                                            // el?.status == 4 ||
                                            // el?.status == 5 ||
                                            // el?.status == 6,
                                        )
                                        .sort(
                                            (x: any, y: any) =>
                                                y.isPrimary - x.isPrimary ||
                                                toNumber(x.peerAccountRef?.split('|')[2]) -
                                                    toNumber(y.peerAccountRef?.split('|')[2]),
                                        )
                                        .map((el: any, _idx: any) => {
                                            const findUserHistory =
                                                topupHistory &&
                                                topupHistory.find((data: any) => data.customerId === viewUserHistory);
                                            let currentUserMax = 0;
                                            let currentUserData = 0;
                                            let endDate: any = moment.utc(showEndDate).format('YYYY-MM-DD');
                                            let isCurrentBillCycle =
                                                currentUsage && Object.keys(currentUsage)[0] === endDate;

                                            if (viewUserHistory && totalDataUsage && !isCurrentBillCycle) {
                                                let currentDataUsage =
                                                    totalDataUsage &&
                                                    totalDataUsage[endDate] &&
                                                    totalDataUsage[endDate].users &&
                                                    totalDataUsage[endDate].users.find(
                                                        (user: any) => user.userId === viewUserHistory,
                                                    );
                                                currentUserData = currentDataUsage?.bytes;
                                                currentUserMax = currentDataUsage?.maxBytes;
                                            } else if (viewUserHistory && currentUsage) {
                                                let currentDataUsage =
                                                    currentUsage &&
                                                    currentUsage[endDate] &&
                                                    currentUsage[endDate].users &&
                                                    currentUsage[endDate].users.find(
                                                        (user: any) => user.userId === viewUserHistory,
                                                    );
                                                currentUserData = currentDataUsage?.bytes;
                                                currentUserMax = currentDataUsage?.maxBytes;
                                            }

                                            return (
                                                <div
                                                    className={
                                                        pauseUserData === el.id
                                                            ? 'AccountLineCardHeight AccountLineCard'
                                                            : viewUserHistory === el.id
                                                            ? 'AccountLineCardHistoryHeight AccountLineCard'
                                                            : 'AccountLineCard'
                                                    }
                                                    key={el.id}
                                                >
                                                    <div className="AccountTopDiv">
                                                        <div className="AccountCusDetails">
                                                            <span
                                                                className={
                                                                    el.status === 4 ? 'cusDetailsLite username' : 'username'
                                                                }
                                                            >
                                                                 {el?.firstName || el?.lastName
                                                                    ? width <= 768 ? textTruncate(returnName(el, "firstName")) + ' ' + textTruncate(returnName(el, "lastName"))?.toUpperCase() : returnName(el, "firstName") + ' ' + returnName(el, "lastName")
                                                                    : convertToOrdinal(
                                                                          el.peerAccountRef?.split('|')[2] - 1,
                                                                      ).toUpperCase() + "'s" + ' LINE'}{' '}
                                                            </span>
                                                            <br />
                                                            {el.status === 4 ? (
                                                                <span className="cusStatus">Disconnected</span>
                                                            ) : (
                                                                <span className="AccountCusSimPref">
                                                                    <span className="AccountCusPrimary">
                                                                        {el &&
                                                                            el.reachNumber &&
                                                                            `(${el.reachNumber.slice(
                                                                                0,
                                                                                3,
                                                                            )}) ${el.reachNumber.slice(
                                                                                3,
                                                                                6,
                                                                            )}-${el.reachNumber.slice(6)} `}
                                                                    </span>
                                                                </span>
                                                            )}
                                                            {el.isPrimary && (
                                                                <span className="AccountCusPrimary">(Primary)</span>
                                                            )}{' '}
                                                        </div>
                                                        <div className="AccountHLine"></div>
                                                        {el.status === 4 ? (
                                                            <>
                                                                <div className="AccountVLine"></div>
                                                                <div className="activationFailed">
                                                                    <div
                                                                        className="showMore"
                                                                        onClick={() => {
                                                                            setPauseUserData('');
                                                                            if (viewUserHistory === el.id) {
                                                                                setViewUserHistory('');
                                                                            } else {
                                                                                setViewUserHistory(el.id);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {viewUserHistory === el.id
                                                                            ? 'Show Less Info'
                                                                            : 'Show More Info'}
                                                                        <img
                                                                            src={
                                                                                viewUserHistory === el.id
                                                                                    ? upArrow
                                                                                    : downArrow
                                                                            }
                                                                            alt="historyIcon"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="AccountCusRightDiv">
                                                                <div
                                                                    className="AccountDataHistory"
                                                                    onClick={() => {
                                                                        setPauseUserData('');
                                                                        if (viewUserHistory === el.id) {
                                                                            setViewUserHistory('');
                                                                            setIsViewMoreData('');
                                                                        } else {
                                                                            setViewUserHistory(el.id);
                                                                        }
                                                                        let occurence = el.peerAccountRef.split('|')[2];
                                                                        TagManager.dataLayer({
                                                                            dataLayer: {
                                                                                event: 'View_Usage_History',
                                                                                accountNo:
                                                                                    user?.meta
                                                                                        ?.customer_statement_number,
                                                                                line_number: occurence,
                                                                            },
                                                                        });
                                                                        // GAAndFBEventsHandler("View_Usage_History", user?.meta?.customer_statement_number,occurence)
                                                                    }}
                                                                >
                                                                    {viewUserHistory === el.id
                                                                        ? 'Hide Usage History'
                                                                        : 'View Usage History'}
                                                                    <span className="historyIcon">
                                                                        <img
                                                                            src={
                                                                                viewUserHistory === el.id
                                                                                    ? upArrow
                                                                                    : downArrow
                                                                            }
                                                                            alt="historyIcon"
                                                                        />
                                                                    </span>
                                                                </div>
                                                                <div className="AccountVLine"></div>
                                                                <div
                                                                    className={
                                                                        // (user.status === 3 && user.isPrimary) ||
                                                                        (el.status === 3 &&
                                                                            !billing?.config?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED || 
                                                                            user?.meta?.suspended_reason === "NonPay Suspension" ||
                                                                            isFraudAcc
                                                                            ) || simSwapInProgress
                                                                            ? 'AccountDataSwitchDisabled AccountDataSwitch'
                                                                            : 'AccountDataSwitch'
                                                                    }
                                                                >
                                                                    <Switch
                                                                        checked={
                                                                            el.isDataCutoff
                                                                                ? !el.isDataCutoff
                                                                                : !el.addedDataCutoff
                                                                        }
                                                                        onChange={() => {
                                                                            setViewUserHistory('');
                                                                            if (pauseUserData === el.id) {
                                                                                setPauseUserData('');
                                                                            } else {
                                                                                setPauseUserData(el.id);
                                                                            }
                                                                        }}
                                                                        disabled={
                                                                            ((el.status === 3 && 
                                                                                !billing?.config?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED) || user?.meta?.suspended_reason === "NonPay Suspension" ||
                                                                                isFraudAcc ||
                                                                                simSwapInProgress
                                                                            )
                                                                        }
                                                                        name="pausedata"
                                                                        inputProps={{
                                                                            'aria-label': 'primary checkbox',
                                                                        }}
                                                                    />
                                                                    <div className="AccountDataText">
                                                                        Data Service
                                                                        {/* {el.isDataCutoff
                                                                            ? 'Data Paused'
                                                                            : !el.addedDataCutoff
                                                                            ? 'Data Enabled'
                                                                            : 'Data Paused'} */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {el.id === pauseUserData && (
                                                        <div className="AccountBottomDiv">
                                                            <div className="AccountHLine"></div>
                                                            <div className="AccountDataDiv">
                                                                <div className="AccountDataNote">
                                                                    {el.isDataCutoff && !el.addedDataCutoff
                                                                        ? `${returnName(el,"firstName")} is out of data. Add data or change your plan to regain full-speed mobile data.`
                                                                        : !el.addedDataCutoff
                                                                        ? `This action will temporarily pause data. Please note that
                                                        Unlimited Talk & Text will still be available. You can enable
                                                        data any time from the web or app.`
                                                                        : `This action will enable data for ${returnName(el,"firstName")}. You can temporarily pause their data anytime from the web or app.`}
                                                                </div>
                                                                <div className="AccountChangePlanButton">
                                                                    <Button
                                                                        onClick={() => 
                                                                            !pauseDataLoader && 
                                                                            handleEnablePauseData(el)}
                                                                        primary={true}
                                                                        disabled={
                                                                            el.isDataCutoff && !el.addedDataCutoff
                                                                        }
                                                                    >
                                                                        {pauseDataLoader ? (
                                                                            <div className="loaderCheck text-center">
                                                                                <CircularProgress />
                                                                            </div>
                                                                        ) : el.addedDataCutoff || el.isDataCutoff ? (
                                                                            'Enable Data'
                                                                        ) : (
                                                                            'Pause Data'
                                                                        )}
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {el.id === viewUserHistory && el.status === 4 && (
                                                        <>
                                                            <div className="HomeBottomLine"></div>
                                                            <div className="BottomDivContent">
                                                                <div className="BottomDivTitle">Line Disconnected</div>
                                                                <div className="BottomDivMsg">
                                                                    {el.lastDisconnectedReason === 0
                                                                        ? 'As requested, your '
                                                                        : 'Your '}
                                                                    line has been disconnected. For any queries or
                                                                    questions please get in touch with our Care Team at{' '}
                                                                    <span>1.800.427.8686</span>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {el.id === viewUserHistory && el.status !== 4 && (
                                                        <div className="AccountBottomHistory">
                                                            <div className="AccountHLine"></div>
                                                            <div className="AccountHistoryDateDiv">
                                                                <span
                                                                    className={!isLeftArrow ? 'arrowDisabled' : ''}
                                                                    onClick={onLeftClickHandler}
                                                                >
                                                                    <img src={leftArrow} alt="leftArrow" />
                                                                </span>
                                                                <div className="AccountHistoryDate">
                                                                    {showStartDate &&
                                                                        moment
                                                                            .utc(showStartDate)
                                                                            .format('MMM DD, YYYY')}{' '}
                                                                    -{' '}
                                                                    {showEndDate &&
                                                                        moment.utc(showEndDate).format('MMM DD, YYYY')}
                                                                </div>
                                                                <span
                                                                    className={!isRightArrow ? 'arrowDisabled' : ''}
                                                                    onClick={onRightClickHandler}
                                                                >
                                                                    <img src={rightArrow} alt="rightArrow" />
                                                                </span>
                                                            </div>
                                                            {!currentUsageError || isRightArrow ? (
                                                                <div className="AccountHistoryDetails">
                                                                    <div className="AccountHistoryDetailsTitle">
                                                                        Total data usage:{' '}
                                                                        <span>
                                                                            {/* {currentUserData
                                                                            ? bytesToSize(currentUserData)
                                                                            : // : dataUsed
                                                                              // ? converDataFromBytes(dataUsed)
                                                                              `0 ${
                                                                                  currentUserMax
                                                                                      ? converDataFromBytes(
                                                                                            currentUserMax,
                                                                                        ).split(' ')[1]
                                                                                      : 'GB'
                                                                              }`} */}
                                                                            {bytesToSize(currentUserData)} of{' '}
                                                                            {currentUserMax
                                                                                ? converDataFromBytes(currentUserMax)
                                                                                : // : maxData
                                                                                  // ? converDataFromBytes(maxData)
                                                                                  currentPlan.planData + ' GB'}
                                                                        </span>
                                                                    </div>
                                                                    <div className="AccountHistoryDetailsTitle">
                                                                        Plan: <span>{user && user.reachPlanId}</span>
                                                                    </div>
                                                                    <div className="AccountHistoryTopupDetails">
                                                                        <div className="AccountHistoryDetailsTitle">
                                                                            Data purchase history:
                                                                            <div
                                                                                className={
                                                                                    !topupHistory || !findUserHistory
                                                                                        ? 'AccountTopupHistoryUnavailable AccountTopupHistory'
                                                                                        : isViewMoreData === el.id
                                                                                        ? 'AccountTopupHistoryScroll AccountTopupHistory'
                                                                                        : 'AccountTopupHistory'
                                                                                }
                                                                            >
                                                                                {isTopupHistoryLoader && (
                                                                                    <div className="loaderCheck text-center">
                                                                                        <CircularProgress />
                                                                                    </div>
                                                                                )}
                                                                                {topupHistory &&
                                                                                    findUserHistory &&
                                                                                    !isTopupHistoryLoader && (
                                                                                        <>
                                                                                            <div className="AccountTopupHistoryTitle">
                                                                                                <div>Amount</div>
                                                                                                <div>Date</div>
                                                                                            </div>
                                                                                            <div className="AccountHLine"></div>

                                                                                            <div
                                                                                                className={
                                                                                                    isViewMoreData !==
                                                                                                    el.id
                                                                                                        ? 'AccountHistoryDataContainer'
                                                                                                        : ''
                                                                                                }
                                                                                            >
                                                                                                {topupHistory &&
                                                                                                    topupHistory.map(
                                                                                                        (
                                                                                                            el: any,
                                                                                                            idx: number,
                                                                                                        ) =>
                                                                                                            viewUserHistory ===
                                                                                                                el.customerId && (
                                                                                                                <div
                                                                                                                    className="AccountHistoryDataDiv"
                                                                                                                    key={
                                                                                                                        idx
                                                                                                                    }
                                                                                                                >
                                                                                                                    <div className="AccountHistoryData">
                                                                                                                        {
                                                                                                                            el.totalData
                                                                                                                        }{' '}
                                                                                                                        GB
                                                                                                                    </div>
                                                                                                                    <div className="AccountHistoryTopupDate">
                                                                                                                        {moment
                                                                                                                            .utc(
                                                                                                                                el.topupDate,
                                                                                                                            )
                                                                                                                            .format(
                                                                                                                                'MMM DD, YYYY',
                                                                                                                            )}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            ),
                                                                                                    )}
                                                                                            </div>
                                                                                        </>
                                                                                    )}
                                                                                {isViewMoreData !== el.id &&
                                                                                    findUserHistory &&
                                                                                    !isTopupHistoryLoader &&
                                                                                    topupHistory &&
                                                                                    topupHistory.length > 3 && (
                                                                                        <div
                                                                                            className="AccountTopupViewMore"
                                                                                            onClick={() =>
                                                                                                setIsViewMoreData(el.id)
                                                                                            }
                                                                                        >
                                                                                            View More
                                                                                        </div>
                                                                                    )}
                                                                                {(!topupHistory || !findUserHistory) &&
                                                                                    !isTopupHistoryLoader && (
                                                                                        <div className="errorTopupHistory">
                                                                                            You don’t have any data
                                                                                            purchase <br />
                                                                                            history in the selected bill
                                                                                            cycle.
                                                                                        </div>
                                                                                    )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="AccountUsageErrorMsg">
                                                                    Failed to load usage history. Kindly refresh the
                                                                    page after some time to try again.
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                            </div>
                        </>
                    )}
                </div>
            ) : (
                <>
                    {(isChangePlan || isReviewPlan || isConfirmPlan) && (
                        <div className="titleContainer">
                            <img src={backArrow} alt="backArrow" className="backArrow" onClick={backHandler} />
                            <div className="selectTitle">
                                {isChangePlan
                                    ? 'Select Plan'
                                    : isReviewPlan
                                    ? `Review Plan ${
                                          currentPlan?.baseLinePrice < selectedPlan?.baseLinePrice
                                              ? 'Upgrade'
                                              : 'Downgrade'
                                      }`
                                    : isConfirmPlan
                                    ? `Confirm Plan ${
                                          currentPlan?.baseLinePrice < selectedPlan?.baseLinePrice
                                              ? 'Upgrade'
                                              : 'Downgrade'
                                      }`
                                    : ''}
                            </div>
                        </div>
                    )}
                    {isChangePlan && (
                        <div className="AccountChangePlan">
                            {planData && planData.length > 0 ? (
                                planData
                                    .sort((a: any, b: any) => {
                                        if (a.planData === b.planData) {
                                            return a.baseLinePrice - b.baseLinePrice;
                                        } else {
                                            return a.planData - b.planData;
                                        }
                                    })
                                    .map((el: any, index: number) => {
                                        let disabledName: boolean =  el?.name === currentPlan?.displayName ||
                                        (!user?.reachPlanChangeDate && el?.name === user?.amendedReachPlanId) 
                                        return (
                                            <div
                                                key={index}
                                                className="AccountCardCheckWidth"
                                                onClick={() => {
                                                    user && !disabledName &&
                                                        selectingPlanHandler(el);
                                                    TagManager.dataLayer({
                                                        dataLayer: {
                                                            event: 'Plan_Select',
                                                            planName: el.name,
                                                        },
                                                    });
                                                    // GAAndFBEventsHandler("Plan_Select", el.name)
                                                }}
                                            >
                                                {user &&
                                                user.amendedReachPlanId === el.name &&
                                                !user.reachPlanChangeDate ? (
                                                    <div className="otherText">
                                                        <span className="newPlanText">New Plan</span> (You'll be moved
                                                        to your new plan starting the next billing cycle. If you'd like
                                                        to cancel this change, please contact us at{' '}
                                                        <span>1.800.427.8686</span>)
                                                    </div>
                                                ) : user && user.reachPlanId === el.name ? (
                                                    <div className="currentPlan">Current Plan</div>
                                                ) : null}
                                                <div
                                                    className={
                                                        user && user.reachPlanId === el.name
                                                            ? 'AccountCheckoutCard borderAddColor'
                                                            : user &&
                                                              user.amendedReachPlanId === el.name &&
                                                              !user.reachPlanChangeDate
                                                            ? 'AccountCheckoutCard addOpacity nextNewPlan'
                                                            : isPlanChangeInitiated
                                                            ? 'AccountCheckoutCard planDisabled'
                                                            : JSON.stringify(selectedPlan) === JSON.stringify(el)
                                                            ? 'AccountCheckoutCard AccountActiveCard'
                                                            : 'AccountCheckoutCard'
                                                    }
                                                >
                                                    <div className="AccountleftDiv">
                                                        <div
                                                            className={
                                                                user && user.reachPlanId === el.name
                                                                    ? 'ActiveAccountcardTitle AccountcardTitle'
                                                                    : 'AccountcardTitle'
                                                            }
                                                        >
                                                            {el && el.name && el.name.replace('The', '')}
                                                        </div>
                                                    </div>
                                                    <div className="horizontalLine"></div>
                                                    <div
                                                        className={
                                                            user && user.reachPlanId === el.name
                                                                ? 'ActiveAccountrightDiv AccountrightDiv'
                                                                : 'AccountrightDiv'
                                                        }
                                                    >
                                                        <div className="AccountgbData">
                                                            {
                                                                //---------cumulative changes-------------
                                                                /* <span className="AccountPlanPrice">
                                                                {`$${(() => {
                                                                    const price =
                                                                        handleChangePlanPrice(el) -
                                                                        (primaryHsdDiscount +
                                                                            secHsdDiscount *
                                                                                (user?.totalActiveLines - 1));
                                                                    const formattedPrice = price.toFixed(2);
                                                                    return formattedPrice < '0'
                                                                        ? '0.00'
                                                                        : formattedPrice;
                                                                })()}`}
                                                            </span> */
                                                            }
                                                            <span className="AccountPlanPrice">
                                                                {`$${(
                                                                    el.baseLinePrice -
                                                                    // ---- HSD Changes ------
                                                                    primaryHsdDiscount
                                                                ).toFixed(2)}`}
                                                            </span>
                                                            <span
                                                                className={
                                                                    JSON.stringify(selectedPlan) === JSON.stringify(el)
                                                                        ? 'AccountmonthDataActive'
                                                                        : 'AccountmonthData'
                                                                }
                                                            >
                                                                /month
                                                                {/* ({user && user.totalActiveLines}{' '}
                                                                {user && user.totalActiveLines === 1 ? 'line' : 'lines'}
                                                                ) */}
                                                            </span>
                                                        </div>
                                                        <div className="Accountsharable">
                                                            {el.streamType} Streaming, Unlimited Voice & Text
                                                        </div>
                                                    </div>
                                                </div>
                                                {user && user.reachPlanId === el.name && isPlanChangeInitiated && (
                                                    <div className="progressNote">Your plan change is in progress…</div>
                                                )}
                                            </div>
                                        );
                                    })
                            ) : (
                                <div className="loaderCheck text-center">
                                    <CircularProgress />
                                </div>
                            )}
                            {planData && planData.length > 0 && (
                                <>
                                    {user && user.totalActiveLines > 1 && (
                                        <div className="AccountSelectPlanNote">
                                            <span>Note:</span> The displayed price pertains to the Primary line only,
                                            <br /> please click on 'Proceed' for the final pricing.
                                        </div>
                                    )}
                                    <div className="AccountChangePlanButton">
                                        <Button
                                            onClick={() => selectPlanAndProceed()}
                                            disabled={!selectedPlan || isPlanChangeInitiated}
                                            primary={true}
                                        >
                                            Proceed
                                        </Button>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                    {isReviewPlan && (
                        <div className="addDataVol">
                            <div className="orderSummary">
                                <div className="summary">
                                    <div className="summaryTitle">Plan change summary</div>
                                    <div className="currentPlan">Current plan</div>
                                    <div className="planInfo">
                                        <div className="planName">
                                            {currentPlan && currentPlan.name}{' '}
                                            <span className="totalLines">
                                                ({numOfLines} {numOfLines == 1 ? 'line' : 'lines'})
                                            </span>
                                        </div>
                                        <div className="planPrice">
                                            {`${currentPlanPrice > 0 ? `$${currentPlanPrice?.toFixed(2)}` : `$0.00`}`}
                                            {/* ${(currentPlanPrice)?.toFixed(2)} */}
                                            <span>/mo.</span>
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                    <div className="newPlan">Selected plan</div>
                                    <div className="planInfo">
                                        <div className="planName">
                                            {selectedPlan && selectedPlan.name}{' '}
                                            <span className="totalLines">
                                                ({numOfLines} {numOfLines == 1 ? 'line' : 'lines'})
                                            </span>
                                        </div>
                                        <div className="planPrice">
                                            {`${newPlanPrice > 0 ? `$${newPlanPrice?.toFixed(2)}` : `$0.00`}`}
                                            {/* ${(newPlanPrice)?.toFixed(2)} */}
                                            <span>/mo.</span>
                                        </div>
                                    </div>
                                </div>
                                {isUpgradePlan ? (
                                    <>
                                        <div className="upgradeNowBtn">
                                            <Button primary={true} onClick={() => handleUpgrageCTA('now')}>
                                                UPGRADE NOW
                                            </Button>
                                        </div>
                                        <div className="upgradeLaterBtn">
                                            <div onClick={() => handleUpgrageCTA('later')}>
                                                UPGRADE ON YOUR NEXT BILLING CYCLE
                                            </div>
                                        </div>{' '}
                                    </>
                                ) : (
                                    <div className="upgradeNowBtn">
                                        {currentPlan?.baseLinePrice > selectedPlan?.baseLinePrice ? (
                                            <Button primary={true} onClick={() => handleUpgrageCTA('later')}>
                                                DOWNGRADE
                                            </Button>
                                        ) : (
                                            <div className="upgradeLaterBtn">
                                                <div onClick={() => handleUpgrageCTA('later')}>
                                                    UPGRADE ON YOUR NEXT BILLING CYCLE
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {isConfirmPlan && (
                        <div className="orderSummary">
                            <div className="summary">
                                <div className="newplanInfo">
                                    <div className="newPlanName">{selectedPlan?.name}</div>
                                    <div className="newPlanPrice">{`$${
                                        newPlanPrice > 0 ? `${newPlanPrice?.toFixed(2)}/mo.` : `0.00`
                                    }`}</div>
                                </div>
                                <div className="line"></div>
                                <div className="totalPlanInfo">
                                    <div className="totalPlanName">Total</div>
                                    <div className="totalplanPrice">{`$${
                                        newPlanPrice > 0 ? `${newPlanPrice?.toFixed(2)}/mo.` : `0.00`
                                    }`}</div>
                                </div>
                                <div className="note">(Taxes & fees extra as applicable)</div>
                                <div className="line"></div>
                                {isUpgradeNow ? (
                                    <div className="info">
                                        Plan upgrade charges will be added to your upcoming invoice.
                                    </div>
                                ) : currentPlan?.baseLinePrice > selectedPlan?.baseLinePrice ? (
                                    <div className="info">
                                        Your plan change will take effect on your next billing cycle.
                                        {/* Plan downgrade charges will be applicable on the next billing cycle. */}
                                    </div>
                                ) : (
                                    <div className="info">
                                        Upgrade on your next billing cycle.
                                        {/* Plan upgrade charges will be applicable on the next billing cycle. */}
                                    </div>
                                )}

                                <div
                                    className="terms"
                                    onClick={() => {
                                        window.open(process.env.REACT_APP_ASTOUND_TERMS_AND_CONDITIONS_URL);
                                    }}
                                >
                                    TERMS & CONDITIONS
                                </div>
                                <div className="summaryConfirmBtn">
                                    <Button primary={true} onClick={!isChangePlanLoader && confirmChangePlan}>
                                        {isChangePlanLoader ? (
                                            <div className="loaderCheck text-center">
                                                <CircularProgress />
                                            </div>
                                        ) : (
                                            'Confirm'
                                        )}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                    {isChangePlanSuccess && (
                        <div className="topupSucess">
                            <img src={successIcon} alt="successIcon" />
                            <div className="lineUserData">Plan Change Successful!</div>
                            <div className="topupFailedMsg">
                                Effective now, your plan has been <br />
                                changed to {selectedPlan?.name}.
                            </div>
                            <div className="summaryConfirmBtn">
                                <Button
                                    primary={true}
                                    onClick={() => {
                                        setIsChangePlanJourney(false);
                                        setIsChangePlanSuccess(false);
                                    }}
                                >
                                    Continue
                                </Button>
                            </div>
                        </div>
                    )}
                    {isChangePlanLaterSuccess && (
                        <div className="topupSucess">
                            <img src={pendingIcon} alt="successIcon" />
                            <div className="lineUserData">Plan Change Scheduled Successfully!</div>
                            <div className="topupFailedMsg">
                                Your new {selectedPlan?.name} plan will take effect <br />
                                on the next billing cycle.
                            </div>
                            <div className="summaryConfirmBtn">
                                <Button
                                    primary={true}
                                    onClick={() => {
                                        setIsChangePlanJourney(false);
                                        setIsChangePlanLaterSuccess(false);
                                    }}
                                >
                                    Continue
                                </Button>
                            </div>
                        </div>
                    )}
                    {isChangePlanFailed && (
                        <div className="topupSucess">
                            <img src={failedIcon} alt="successIcon" />
                            <div className="lineUserData">Plan Change Request Failed</div>
                            <div className="topupFailedMsg">
                                Sorry, your request for plan change could not be completed due to <br />
                                an unexpected error.
                            </div>
                            <div className="summaryConfirmBtn">
                                <Button
                                    primary={true}
                                    onClick={() => {
                                        setIsChangePlan(true);
                                        setIsChangePlanFailed(false);
                                    }}
                                >
                                    TRY AGAIN
                                </Button>
                            </div>
                        </div>
                    )}
                </>
            )}
            <Footer isFixed={true} />
        </div>
    );
};

export default AstoundAccount;
